module.exports = __webpack_public_path__ + "static/media/editor.b4f9385f.png";